/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Button,
  Card,
  HStack,
  IconButton,
  Spinner,
  Stack,
  Text,
  Tooltip,
  Wrap,
  WrapItem,
} from '@mybridge/ui';
import moment from 'moment';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { MyNetworkContext } from 'v4/components/network/context';
import { MyNetworkUserCard } from 'v4/components/network/network-card-full';
import { isMobile } from 'react-device-detect';
import { MyNetworkUserCardBordered } from 'v4/components/network/network-card-new';
import {MyNetworkCircleCardMenu} from '../../../profile/network/circle-menu';
import {
  HandShakeSimpleIcon,
  ReminderNewIcon,
  RemoveNewIcon,
} from '@mybridge/icons';
import { useRouter } from 'next/router';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { NetworkListingNotFound } from '../../404';

export const MyNetworkRequestsSentListing = forwardRef(
  ({ limit,onShowAll, ...props }, ref) => {
    const {
      requestsSent,
      refetchRequestsSent,
      requestsSentIsFetching,
      requestsSentIsLoading,
      unfriendUser,
      unfriendLoading,
      remindHandshake,
      remindHandshakeLoading,
      selectedUser,
      setSelectedUser,
      removeHandshakeRequestDisc,
      revokeHandhsakeRequest,
      handleHandshakeSendRevoke,
    } = useContext(MyNetworkContext);

    const [showAll, setShowAll] = useState(false);
    const { pathname} = useRouter();
    const { t } = useTranslator();
    
    useEffect(() => {
      refetchRequestsSent?.();
    }, []);

    useEffect(() => {
      onShowAll?.(showAll);
    }, [showAll]);

    if ((requestsSentIsFetching || requestsSentIsLoading) && !isMobile) {
      return (
        // Add a fixed height container to prevent layout shift
        <Stack spacing={6} minH="249px" w="100%">
          <HStack justifyContent="center" alignItems="center" h="100%" w="100%">
            <Spinner size="lg" />
          </HStack>
        </Stack>
      );
    }

    // Define which paths should show limited cards
    const isNetworkPage = pathname === '/profile/network';

    const loading = requestsSentIsFetching || requestsSentIsLoading;

    // Determine the requests to display based on the showAll state
    const displayedRequests = showAll
      ? requestsSent
      : requestsSent?.slice(0, limit || 6);


    return (
      <>
        <Stack spacing={6}>
          {requestsSent?.length ? (
            <>
              {/* Show the "Show All" button if there are more than 6 requests and we're not showing all */}
              {requestsSent?.length > 6 && !showAll && (
                <HStack justifyContent="flex-end">
                  <Button
                    variant="transparent"
                    color="#868585"
                    onClick={() => setShowAll(true)}
                  >
                    Show All ({requestsSent.length})
                  </Button>
                </HStack>
              )}
              <Wrap spacing={3}   px={3}>
                {displayedRequests?.map?.((pi, piIndex) => (
                  <WrapItem
                    key={piIndex}
                    maxW={['49%', '30%', '190px']}
                    flexGrow={['1', '1', 0]}
                    flexShrink={['1', '1', 0]}
                    flex="auto"
                    mb="10px"
                  
                  >
                    <MyNetworkUserCardBordered
                      user={pi?.user_info}
                      key={piIndex}
                      from={props?.from}
                      createdAt={pi?.created_at}
                      flexWrap={isMobile ? true : false}
                      isInvitations
                      actions={
                        <>
                          <HStack justifyContent="center">
                            <Tooltip label="Withdraw">
                              <IconButton
                                bg="none"
                                width="40px"
                                height="40px"
                                borderRadius="50%"
                                border="1px solid #00000033"
                                icon={<HandShakeSimpleIcon color="rgb(179, 140, 140)" />}
                                onClick={() =>
                                  handleHandshakeSendRevoke(pi?.user_info)
                                }
                              />
                            </Tooltip>
                            <Tooltip label="Remind">
                              <IconButton
                                isLoading={
                                  selectedUser?.id === pi?.user_info?.id &&
                                  remindHandshakeLoading
                                }
                                onClick={() => {
                                  setSelectedUser(pi?.user_info);
                                  remindHandshake(pi);
                                }}
                                bg="none"
                                width="40px"
                                height="40px"
                                borderRadius="50%"
                                border="1px solid #00000033"
                                icon={<ReminderNewIcon />}
                              />
                            </Tooltip>
                            <MyNetworkCircleCardMenu user={pi?.user_info} refreshFn={refetchRequestsSent}/>
                          </HStack>
                        </>
                      }
                    />
                  </WrapItem>
                ))}
              </Wrap>
            </>
          ) : (
            !loading && <HStack justifyContent="center">
              <Stack alignItems="center">
                <NetworkListingNotFound />
                <Text>{t('profileNetwork.noPendingInvitations') || "No pending invitations"}</Text>
              </Stack>
            </HStack>
            // <>
            //   {!isNetworkPage && <HStack justifyContent="flex-start">
            //     <Text>{t('profileNetwork.noPendingInvitations') || "No pending invitations"}</Text>
            //   </HStack>}
            // </>
          )}
        </Stack>
      </>
    );
  }
);
